export { default } from "../defineProperty/_index.mjs"